$(document).ready(function () {
  const galleryItemSelector =
    ".product-gallery__thumbnail, .product-gallery__media";

  function normalizedPath(source) {
    if (!source) return "";

    try {
      return new URL(source, window.location.origin).pathname;
    } catch (error) {
      return "";
    }
  }

  function showVariantMedia($swatch) {
    // Colour names are compared case-insensitively: image alt text is often typed in mixed case
    // ("Desert Sand") while the variant and its swatch read "DESERT SAND".
    const match = $swatch.find("span").first().text().trim().toLowerCase();

    if (!match) return;

    const $galleryItems = $(galleryItemSelector);
    let $matchingItems = $galleryItems
      .find("img")
      .filter(function () {
        return ($(this).attr("alt") || "").trim().toLowerCase() === match;
      })
      .closest(galleryItemSelector);

    if ($matchingItems.length === 0) {
      const swatchImagePath = normalizedPath(
        $swatch.find("img").first().attr("src")
      );

      if (swatchImagePath) {
        $matchingItems = $galleryItems
          .find("img")
          .filter(function () {
            return normalizedPath(this.currentSrc || this.src) === swatchImagePath;
          })
          .closest(galleryItemSelector);
      }
    }

    if ($matchingItems.length === 0) {
      $galleryItems.show();
      return;
    }

    $galleryItems.hide();
    $matchingItems.show();
    $matchingItems
      .filter(".product-gallery__thumbnail")
      .first()
      .click();
  }

  $(".media-swatch").on("click", function () {
    $(".media-swatch").removeClass("active");
    $(this).addClass("active");
    showVariantMedia($(this));
  });

  const $selectedSwatch = $(
    ":checked + .media-swatch, .media-swatch.is-selected"
  ).first();

  if ($selectedSwatch.length) {
    showVariantMedia($selectedSwatch);
  }
});
/**
 * Keep the status-only stock indicator synchronized with the selected variant.
 * Inventory quantities are intentionally never rendered. The theme's <variant-inventory>
 * element switches between the per-variant "In stock" / "Out of Stock" items; this only
 * makes sure the indicator stays visible as long as a variant is selected.
 */
document.addEventListener("variant:change", (event) => {
  const formId = event.target?.getAttribute?.("id");
  const variantId = event.detail?.variant?.id;

  if (!formId) return;

  document
    .querySelectorAll('variant-inventory.stock-status[form="' + CSS.escape(formId) + '"]')
    .forEach((status) => {
      const selectedItem = variantId == null
        ? null
        : status.querySelector(
            '[data-variant-id="' + CSS.escape(String(variantId)) + '"]'
          );

      status.hidden = !selectedItem;
    });
});